import { getLogoRatioFromImageProperties } from '@constants/file';
import { useAppSelector } from '@core/store';
import { ImageProperties } from '@types';

export interface LogoRatioConfig {
  image_properties?: ImageProperties | null;
}

const useLogoRatio = () => {
  const orgLogoRatio = useAppSelector((state) =>
    getLogoRatioFromImageProperties(
      (state.user.orgConfig as LogoRatioConfig | null)?.image_properties
    )
  );
  const branchLogoRatio = useAppSelector(
    (state) => state.branchConfig.logoRatio
  );

  return { orgLogoRatio, branchLogoRatio };
};

export default useLogoRatio;
